/* Accordion */

jQuery(document).ready(function ($) {
    initializeAccordions();
});

function initializeAccordions() {
    $("#accordion").accordion(
        {
            heightStyle: "content"
        }
    );

    $(".tsi-accordion").accordion(
        {
            active: false,
            collapsible: true,
            heightStyle: "content"
        }
    );
}